import './Cell.scss';

export const Cell_Image = ({ imgUrl }) => {
  return (
    <div>
      <img src={imgUrl} />
    </div>
  );
};
